
// src/actions/chat-messages.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_CHAT_MESSAGES = "FETCH_CHAT_MESSAGES"
export const FETCH_CHAT_MESSAGES_REQUESTED = "FETCH_CHAT_MESSAGES_REQUESTED"
export const FETCH_CHAT_MESSAGES_COMPLETED = "FETCH_CHAT_MESSAGES_COMPLETED"
export const FETCH_CHAT_MESSAGES_FAILED = "FETCH_CHAT_MESSAGES_FAILED"

export function fetchChatMessagesRequested(chat_room_id) {
  return {
    type: FETCH_CHAT_MESSAGES_REQUESTED,
    chat_room_id,
  }
}

export function fetchChatMessages(chat_room_id, offset) {
  return function(dispatch) {
    dispatch(fetchChatMessagesRequested(chat_room_id))
    return api.get(`/chat_messages/${chat_room_id}`, { offset, with_meta_info: true })
        .then((results)=> {
          dispatch(fetchChatMessagesCompleted(chat_room_id, results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchChatMessagesFailed(chat_room_id, error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchChatMessagesCompleted(chat_room_id, results, offset) {
  return {
    type: FETCH_CHAT_MESSAGES_COMPLETED,
    results, offset, chat_room_id,
  }
}

export function fetchChatMessagesFailed(chat_room_id, error) {
  return {
    type: FETCH_CHAT_MESSAGES_FAILED,
    error, chat_room_id
  }
}

export const POST_CHAT_MESSAGE = "POST_CHAT_MESSAGE"
export const POST_CHAT_MESSAGE_REQUESTED = "POST_CHAT_MESSAGE_REQUESTED"
export const POST_CHAT_MESSAGE_COMPLETED = "POST_CHAT_MESSAGE_COMPLETED"
export const POST_CHAT_MESSAGE_FAILED = "POST_CHAT_MESSAGE_FAILED"

export function postChatMessageRequested(chat_room_id, withFiles) {
  return {
    type: POST_CHAT_MESSAGE_REQUESTED,
    chat_room_id, withFiles
  }
}

export function postChatMessage(chat_room_id, message, upload_files = undefined, upload_videos = undefined, attach_json = undefined) {
  return function(dispatch) {
    dispatch(postChatMessageRequested(chat_room_id, !!upload_files || !!upload_videos || !!attach_json))
    return api.post(`/chat_messages/${chat_room_id}`, { message, upload_files, upload_videos, attach_json })
        .then((results)=> {
          dispatch(postChatMessageCompleted(chat_room_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(postChatMessageFailed(chat_room_id, error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function postChatMessageCompleted(chat_room_id, results) {
  return {
    type: POST_CHAT_MESSAGE_COMPLETED,
    chat_room_id, results,
  }
}

export function postChatMessageFailed(chat_room_id, error) {
  return {
    type: POST_CHAT_MESSAGE_FAILED,
    chat_room_id, error,
  }
}

export const DELETE_CHAT_MESSAGE = "DELETE_CHAT_MESSAGE"
export const DELETE_CHAT_MESSAGE_REQUESTED = "DELETE_CHAT_MESSAGE_REQUESTED"
export const DELETE_CHAT_MESSAGE_COMPLETED = "DELETE_CHAT_MESSAGE_COMPLETED"
export const DELETE_CHAT_MESSAGE_FAILED = "DELETE_CHAT_MESSAGE_FAILED"

export function deleteChatMessageRequested() {
  return {
    type: DELETE_CHAT_MESSAGE_REQUESTED
  }
}

export function deleteChatMessage(chat_room_id, message_id) {
  return function(dispatch) {
    dispatch(deleteChatMessageRequested())
    return api.delete(`/chat_messages/${message_id}`)
        .then((results)=> {
          dispatch(deleteChatMessageCompleted(results, chat_room_id))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteChatMessageFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteChatMessageCompleted(results, chat_room_id) {
  return {
    type: DELETE_CHAT_MESSAGE_COMPLETED,
    chat_room_id, results,
  }
}

export function deleteChatMessageFailed(error) {
  return {
    type: DELETE_CHAT_MESSAGE_FAILED,
    error,
  }
}

export const CLEAR_CHAT_MESSAGES = "CLEAR_CHAT_MESSAGES"

export function clearChatMessages() {
  return {
    type: CLEAR_CHAT_MESSAGES
  }
}

export const LOAD_CHAT_MESSAGE = "LOAD_CHAT_MESSAGE"

export function loadChatMessage(chat, appending) {
  return {
    type: LOAD_CHAT_MESSAGE,
    chat, appending
  }
}

export const REMOVE_CHAT_MESSAGE = "REMOVE_CHAT_MESSAGE"

export function removeChatMessage(chat_room_id, message_id) {
  return {
    type: REMOVE_CHAT_MESSAGE,
    chat_room_id, message_id
  }
}



// WEBPACK FOOTER //
// ./src/actions/chat-messages.js